import {BookingInfoPatch} from "./BookingInfo";
import {PatchWithAuth} from "../client/Patch";
import {DeleteWithAuth} from "../client/Delete";

export async function ApproveBooking(bookingId: number, sendEmail: boolean, token: any) {
    const patchBody: BookingInfoPatch = {
        approved: true
    };
    await PatchWithAuth(`/api/bookings/${bookingId}?sendEmail=${sendEmail}`, token, patchBody)
}

export async function DeclineBooking(bookingId: number, sendEmail: boolean, token: any) {
    await DeleteWithAuth(`/api/bookings/${bookingId}?sendEmail=${sendEmail}`, token)
}